.text {
  display: inline-block;
  text-box-edge: inherit;
  text-box-trim: inherit;
  width: 100%;
}
